import {
  Action_GetAllRoleInUser,
  Action_GetAllRoleInUserSuccess
} from "actions/User/actionTypes";

const initialState = {
  AllRoleUser: {},
};

const Reducer_GetAllRoleInUser = (state, action) => ({
  ...state,
  AllRoleUser: action.payload,
});
const Reducer_GetAllRoleInUserSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    AllRoleUser: action.payload,
  };
};
// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetAllRoleInUser:
      return Reducer_GetAllRoleInUser(state, action);
    case Action_GetAllRoleInUserSuccess:
      return Reducer_GetAllRoleInUserSuccess(state, action);


    default:
      return state;
  }
};
export default authReducer;
